export default __webpack_public_path__ + "static/media/480_business02-jp-web.2fcec82e.png";